var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2206 11.6347C18.3397 12.417 14.5808 14.0361 8.94364 16.4921C8.02826 16.8562 7.54874 17.2123 7.50509 17.5605C7.43131 18.149 8.16825 18.3807 9.17178 18.6962C9.30828 18.7392 9.44972 18.7836 9.59472 18.8308C10.582 19.1517 11.9102 19.5272 12.6006 19.5421C13.2269 19.5556 13.9259 19.2974 14.6976 18.7675C19.9646 15.2121 22.6834 13.4151 22.8541 13.3764C22.9745 13.349 23.1414 13.3147 23.2544 13.4152C23.3675 13.5157 23.3564 13.706 23.3444 13.757C23.2714 14.0683 20.3786 16.7576 18.8816 18.1494C18.4149 18.5833 18.0839 18.891 18.0162 18.9613C17.8646 19.1188 17.7101 19.2677 17.5616 19.4109C16.6444 20.2951 15.9566 20.9582 17.5997 22.041C18.3894 22.5614 19.0212 22.9917 19.6516 23.421C20.34 23.8898 21.0267 24.3574 21.9151 24.9397C22.1414 25.0881 22.3576 25.2422 22.5682 25.3923C23.3693 25.9635 24.0891 26.4766 24.9784 26.3948C25.4951 26.3473 26.0288 25.8614 26.2999 24.4123C26.9405 20.9877 28.1997 13.5676 28.4907 10.51C28.5162 10.2421 28.4841 9.89925 28.4583 9.74875C28.4326 9.59825 28.3787 9.38382 28.1831 9.22508C27.9514 9.03709 27.5938 8.99744 27.4338 9.00012C26.7065 9.01307 25.5907 9.40107 20.2206 11.6347Z",
    fill: "#8ABE84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.1f8e5419ff92f0ce948f87067e43c3ee.svg";
export { ForwardRef as ReactComponent };